export const telephone = '01 41 73 74 75';
